module.exports = __webpack_public_path__ + "static/media/_-产品与服务_02.45c49454.jpg";